import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AsyncButton, SaveStates, Tooltip } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import CheckIcon from '@mui/icons-material/Check';
import { Box, Button, buttonClasses } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LinkCard from '../link-card';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var OnlineStage = function OnlineStage(_ref) {
  var _ref3;

  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var previewDescription = stage.previewDescription,
      previewImageUrl = stage.previewImageUrl,
      previewTitle = stage.previewTitle,
      url = stage.url;

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      completed = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setCompleted = _useToggle2$.on,
      setUncompleted = _useToggle2$.off;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(setUncompleted, [stage]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex'
      },
      children: [/*#__PURE__*/_jsx(Button, {
        sx: (_ref3 = {
          mx: 1
        }, _defineProperty(_ref3, "&.".concat(buttonClasses.contained, ":visited"), {
          color: function color(t) {
            return t.palette.primary.contrastText;
          }
        }), _defineProperty(_ref3, "&.".concat(buttonClasses.text, ":visited"), {
          color: function color(t) {
            return t.palette.primary.main;
          }
        }), _ref3),
        size: "large",
        variant: completed ? 'text' : 'contained',
        href: url !== null && url !== void 0 ? url : '',
        onClick: setCompleted,
        target: "_blank",
        disabled: completed,
        rel: "noopener noreferrer",
        children: completed ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(CheckIcon, {
            sx: {
              mr: 1
            }
          }), t('Review submitted')]
        }) : t('Submit a review')
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: completed ? '' : t('You must first submit a review'),
        arrow: true,
        disableFocusListener: true,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(AsyncButton, {
            status: mutationValue,
            sx: {
              mx: 1
            },
            variant: !completed ? 'text' : 'contained',
            disabled: !completed || DE.isSuccess(completeStageStatus),
            onClick: function onClick() {
              return completeStage({
                g2ReviewInput: {
                  stageID: stage.id,
                  activityID: activity === null || activity === void 0 ? void 0 : activity.id
                }
              });
            }
          })
        })
      })]
    }),
    "data-element": "StageLayout",
    "data-component": "OnlineStage",
    "data-source-file": "index.tsx",
    children: url && /*#__PURE__*/_jsx(LinkCard, {
      previewDescription: previewDescription !== null && previewDescription !== void 0 ? previewDescription : '',
      previewImageUrl: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : '',
      previewTitle: previewTitle !== null && previewTitle !== void 0 ? previewTitle : '',
      url: url,
      onClick: setCompleted
    })
  });
};

export default OnlineStage;